import { useState } from "react";
import {
    Container,
    Row,
    Col
} from "reactstrap";

import {
    FiChevronDown,
    FiHelpCircle
} from "react-icons/fi";

import "./CourseFAQ.css";

function CourseFAQ({ faqs = [] }) {

    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(
            activeIndex === index ? null : index
        );
    };

    if (!faqs.length) {
        return null;
    }

    return (
        <section className="course-faq">

            <Container>

                {/* Header */}

                <div className="course-faq-header">

                    <span className="course-faq-label">
                        FAQ
                    </span>

                    <h2>
                        Frequently Asked Questions
                    </h2>

                    <p>
                        Frequently asked questions and answers.
                    </p>

                </div>


                {/* FAQ List */}

                <Row className="justify-content-center">

                    <Col
                        lg="9"
                        md="11"
                        sm="12"
                    >

                        <div className="course-faq-list">

                            {faqs.map((faq, index) => {

                                const isActive =
                                    activeIndex === index;

                                return (
                                    <div
                                        className={`course-faq-item ${
                                            isActive
                                                ? "course-faq-item-active"
                                                : ""
                                        }`}
                                        key={index}
                                    >

                                        <button
                                            type="button"
                                            className="course-faq-question"
                                            onClick={() =>
                                                toggleFAQ(index)
                                            }
                                        >

                                            <div className="course-faq-question-left">

                                                <span className="course-faq-icon">
                                                    <FiHelpCircle />
                                                </span>

                                                <span className="course-faq-question-text">
                                                    {faq.question}
                                                </span>

                                            </div>


                                            <span className="course-faq-toggle">
                                                <FiChevronDown />
                                            </span>

                                        </button>


                                        {isActive && (

                                            <div className="course-faq-answer">

                                                {Array.isArray(faq.answer) ? (
                                                    faq.answer.map(
                                                        (paragraph, paragraphIndex) => (
                                                            <p key={paragraphIndex}>
                                                                {paragraph}
                                                            </p>
                                                        )
                                                    )
                                                ) : (
                                                    <p>
                                                        {faq.answer}
                                                    </p>
                                                )}

                                            </div>

                                        )}

                                    </div>
                                );
                            })}

                        </div>

                    </Col>

                </Row>

            </Container>

        </section>
    );
}

export default CourseFAQ;